import { render, staticRenderFns } from "./OMSRuleHistory.vue?vue&type=template&id=0e4350fe"
import script from "./OMSRuleHistory.vue?vue&type=script&lang=js"
export * from "./OMSRuleHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports